/**
* 财务管理 服务费开票
*/
<template>
  <div class="contianer">
    <!-- 服务费开票 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="服务费开票" name="first">
        <el-form :inline="true" :model="formInline" class="user-search">
          <el-form-item label="">
            <el-date-picker
              v-model="searchDate"
              type="monthrange"
              range-separator="至"
              start-placeholder="账单开始月份"
              end-placeholder="账单结束月份">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="search">查询</el-button>
            <el-button size="small" type="success" @click="Invoicing()">申请开票</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <div style="height: 550px;overflow-y: auto">
          <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                    element-loading-text="拼命加载中" style="width: 85%;">
            <el-table-column align="center" type="selection" width="80">
            </el-table-column>
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="账单日期" width="150">
            </el-table-column>
            <el-table-column prop="withdraw_code" label="单据名称" min-width="200" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="fee" label="服务费金额" width="180" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.fee}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="invoicable_money" label="可开票金额" width="180" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.invoicable_money}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_status" label="开票状态" width="150">
              <template slot-scope="scope">
                <div>{{scope.row.invoice_status==1653?'开票中':scope.row.invoice_status==1651?'已开票':'待开票'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="detail(scope.row.id)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <!-- 开票记录 -->
      <el-tab-pane label="开票记录" name="second">
        <el-form :inline="true" :model="formInline1" class="user-search">
          <el-form-item label="">
            <el-date-picker
              v-model="searchDate1"
              type="monthrange"
              range-separator="至"
              start-placeholder="账单开始月份"
              end-placeholder="账单结束月份">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline1.invoice_status" placeholder="请选择开票状态" clearable>
              <el-option label="开票中" value="1653"></el-option>
              <el-option label="已开票" value="1651"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input size="small" v-model="formInline1.apply_no" placeholder="发票申请单号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="search1">查询</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <div style="height: 550px;overflow-y: auto">
          <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="80">
            </el-table-column>
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="申请时间" width="135" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="apply_no" label="发票申请单号" width="160" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="invoice_maker" label="开票方" min-width="180" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="withdraw_code" label="单据号" width="180" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="invoice_title" label="发票抬头" width="180" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="invoicable_money" label="发票金额" width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.invoicable_money}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_type" label="发票类型" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.invoice_type=='182'">增值税专用发票</div>
                <div v-else-if="scope.row.invoice_type=='181'">增值税电子发票</div>
                <div v-else-if="scope.row.invoice_type=='180'">增值税普通发票</div>
                <div v-else-if="scope.row.invoice_type=='183'">全电发票(专用发票)</div>
                <div v-else-if="scope.row.invoice_type=='184'">全电发票(普通发票)</div>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_status" label="开票状态" width="100">
              <template slot-scope="scope">
                <div plain style="color: #E6A23C" v-if="scope.row.invoice_status=='1653'">
                  开票中
                </div>
                <div plain style="color: #F56C6C" v-else-if="scope.row.invoice_status=='1650'">
                  待开票
                </div>
                <div plain style="color: #409eff" v-else>
                  已开票
                </div>
              </template>
            </el-table-column>
            <el-table-column align="left" label="操作" width="134">
              <template slot-scope="scope">
                <el-button type="text" size="mini" v-if="scope.row.invoice_ele_url"
                           @click="downloadInvoice(scope.row.invoice_ele_url)">
                  下载
                </el-button>
                <el-button type="text" size="mini"
                           @click="detailApply(scope.row.id,scope.row.apply_no,scope.row.delivery_no,scope.row.delivery_name)">
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
      </el-tab-pane>

      <!-- 发票信息（抬头）-->
      <el-tab-pane label="发票信息（抬头）" name="third">
        <div class="tions">
          <p class="title f20 color409EFF fontWeight mb20">发票抬头信息</p>
          <div class="billing_information">
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">发票抬头</p>
                <span class="f14 color333">{{invoiceData.invoice_title}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">注册地址</p>
                <span class="f14 color333">{{invoiceData.enterprise_address}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">纳税人识别号</p>
                <span class="f14 color333">{{invoiceData.taxpayer_no}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">注册电话</p>
                <span class="f14 color333">{{invoiceData.enterprise_tel}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">开户银行</p>
                <span class="f14 color333">{{invoiceData.bank_name}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">邮寄地址</p>
                <span class="f14 color333">{{invoiceData.addr}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">开户银行账号</p>
                <span class="f14 color333">{{invoiceData.bank_account}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">电子邮箱</p>
                <span class="f14 color333">{{invoiceData.email}}</span>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!-- 发票电子邮箱 -->
      <el-tab-pane label="发票电子邮箱" name="five">
        <el-form :inline="true" :model="formInline4" class="user-search">
          <el-form-item label="">
            <el-input size="small" v-model="formInline4.email" placeholder="电子邮箱 " clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="search4">查询</el-button>
            <el-button size="small" type="primary" @click="addEmail" class="add-button">新增</el-button>
            <el-button size="small" type="primary" @click="editEmail" class="edit-button">修改</el-button>
            <el-button size="small" type="danger" @click="delEmail">删除</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <div style="height: 530px;overflow-y: auto">
          <el-table size="small" :data="listData4" highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange1"
                    element-loading-text="拼命加载中" style="width: 50%;">
            <el-table-column align="center" type="selection" width="80">
            </el-table-column>
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{pageparm4.pageSize * (pageparm4.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="email" label="电子邮箱地址" min-width="410" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="is_default" label="是否默认" width="76">
              <template slot-scope="scope">
                <el-switch @change="changeEmailStatus(scope.row.id)" :disabled="scope.row.is_default?true:false"
                           v-model="scope.row.is_default"
                           :active-value="1"
                           :inactive-value="0"
                           active-color="#409EFF">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm4" @callFather="callFather4"></Pagination>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                   :title="dialogTitle1"
                   :visible.sync="emailDialogVisible"
                   width="30%"
                   :before-close="handleClose1"
                   center>
          <el-form label-width="125px" :model="emailForm" :rules="rules1" ref="emailForm" class="financeForm">
            <el-form-item label="电子邮箱" prop="email" class="relative r50">
              <el-input size="small" v-model="emailForm.email" auto-complete="off" clearable
                        placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="是否为默认" prop="is_default" class="relative r50">
              <el-select v-model="emailForm.is_default" placeholder="请选择是否为默认" clearable>
                <el-option v-for="item in is_default" :key="item.value" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
                <el-button @click="emailDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEmail('emailForm')">保存</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
    <!-- 详情界面 -->
    <el-dialog title="对账单详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="detailVisible"
               width="50%" center>
      <div class="billing_information">
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">订单号</p>
            <span class="f14 color333">{{detailData.source_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">订单金额</p>
            <span class="f14 color333">{{detailData.order_amount||detailData.order_amount==0?'￥'+detailData.order_amount:''}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">商城服务费</p>
            <span class="f14 color333">{{detailData.service_fee||detailData.service_fee==0?'￥'+detailData.service_fee:''}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">待划拨金额</p>
            <span class="f14 color333">{{detailData.wait_allocate_amount||detailData.wait_allocate_amount==0?'￥'+detailData.wait_allocate_amount:''}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">划拨金额</p>
            <span class="f14 color333">{{detailData.allocated_amount||detailData.allocated_amount==0?'￥'+detailData.allocated_amount:''}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">划拨时间</p>
            <span class="f14 color333">{{detailData.allocated_time}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">退款单号</p>
            <span class="f14 color333">{{detailData.refund_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">退款时间</p>
            <span class="f14 color333">{{detailData.refund_time}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">银联交易号</p>
            <span class="f14 color333">{{detailData.billNo}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">订单支付时间</p>
            <span class="f14 color333">{{detailData.pay_success_time}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">售后服务单号</p>
            <span class="f14 color333">{{detailData.service_code}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">关联账单编号</p>
            <span class="f14 color333">{{detailData.ref_bill_codes}}</span>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 开票记录-查看详情界面 -->
    <el-dialog title="开票详情" :visible.sync="applyVisible" width="50%" @click="closeDialog" center>
      <div style="display: flex; margin: 30px 0 20px 0;">
        <h2 style="font-size: 16px; margin-right: 20px; font-width: 700; line-height: 0;">开票进度</h2>
        <el-button v-if="invoiceInfo.invoice_ele_url" size="mini" type="primary" plain
                   @click="downloadInvoice(invoiceInfo.invoice_ele_url)">下载发票
        </el-button>
        <el-popover
          placement="right"
          width="700"
          trigger="click">
          <div style="height: 50px;line-height: 50px;text-align: center"><span style="margin-right: 20px">{{delivery_company_name||delivery_name}}</span>
            单号：{{delivery_no}}
          </div>
          <el-table :data="deliveryData">
            <el-table-column width="200" property="create_time" label="时间"></el-table-column>
            <el-table-column width="500" property="log" label="内容"></el-table-column>
          </el-table>
          <el-button size="mini" type="primary" plain slot="reference" @click="lookDelivery()" v-if="delivery_no">查看物流
          </el-button>
        </el-popover>
      </div>
      <el-steps class="logs" :active="logsLength" finish-status="success" align-center>
        <el-step :title="log.content" :description="log.create_time" v-for="log in logs" :key="log.content"></el-step>
      </el-steps>
      <template>
        <div style="display: flex; margin: 30px 0 20px 0;">
          <h2 style="font-size: 16px; margin-right: 20px; font-width: 700; line-height: 0;">开票金额</h2>
          <el-button size="mini" type="primary" plain @click="exportFile()">导出明细</el-button>
        </div>
        <div style="width: 100%; height: 160px;overflow-y: auto;">
          <el-table size="small" :data="amountData"
                    highlight-current-row v-loading="loading" show-summary :summary-method="getSummaries"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="80">
            </el-table-column>
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="账单月份" width="120">
            </el-table-column>
            <el-table-column prop="withdraw_code" label="单据号" min-width="160">
            </el-table-column>
            <el-table-column prop="fee" label="服务费金额" width="120">
              <template slot-scope="scope">
                <div>￥{{scope.row.fee}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="invoicable_money" label="可开金额" width="160">
              <template slot-scope="scope">
                <div>￥{{scope.row.invoicable_money}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>

      <div style="margin-top: 30px">
        <el-descriptions title="发票抬头信息" :column="2" border>
          <el-descriptions-item label="发票抬头" label-class-name="my-label">
            {{invoiceInfo.invoice_title}}
          </el-descriptions-item>
          <el-descriptions-item label="注册地址" label-class-name="my-label">
            {{invoiceInfo.enterprise_address}}
          </el-descriptions-item>
          <el-descriptions-item label="纳税识别号" label-class-name="my-label">
            {{invoiceInfo.taxpayer_no}}
          </el-descriptions-item>
          <el-descriptions-item label="注册电话" label-class-name="my-label">
            {{invoiceInfo.enterprise_tel}}
          </el-descriptions-item>
          <el-descriptions-item label="开户银行" label-class-name="my-label">
            {{invoiceInfo.bank_name}}
          </el-descriptions-item>
          <el-descriptions-item label="发票内容" label-class-name="my-label">
            {{invoiceInfo.invoice_detail}}
          </el-descriptions-item>
          <el-descriptions-item label="开户银行账号" label-class-name="my-label">
            {{invoiceInfo.bank_account}}
          </el-descriptions-item>
          <el-descriptions-item label="电子邮箱" label-class-name="my-label">
            {{invoiceInfo.invoice_email}}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="addInvoiceVisible" title="开票申请"
               :close-on-click-modal="false" :close-on-press-escape="false" width="55%" top="7vh" center>
      <p class="title f20 color333 fontWeight mb20">开票金额</p>
      <el-table size="small" :data="InvoicineData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                highlight-current-row v-loading="loading" border show-summary
                :summary-method="getSummaries"
                element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 5px">
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column prop="create_time" label="账单月份" width="150">
        </el-table-column>
        <el-table-column prop="withdraw_code" label="单据号" min-width="200">
        </el-table-column>
        <el-table-column prop="fee" label="服务费金额" width="180">
          <template slot-scope="scope">
            <div>￥{{scope.row.fee}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="invoicable_money" label="可开票金额" width="180">
          <template slot-scope="scope">
            <div>￥{{scope.row.invoicable_money}}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="margin-top: 15px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="InvoicineData.length"
        >
        </el-pagination>
      </div>
<!--      <div style="color: #409EFF;margin-bottom: 20px;margin-top: 10px">注意：若合计可开票金额小于1000元，将不能开票！</div>-->
      <div class="billing_information" style="margin-bottom: 20px;margin-top: 20px;">
        <p class="title f20 color333 fontWeight mb20">发票抬头信息</p>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票抬头</p>
            <span class="f14 color333">{{invoiceData.invoice_title}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">纳税人识别号</p>
            <span class="f14 color333">{{invoiceData.taxpayer_no}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">开户银行</p>
            <span class="f14 color333">{{invoiceData.bank_name}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">开户银行账号</p>
            <span class="f14 color333">{{invoiceData.bank_account}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">注册地址</p>
            <span class="f14 color333">{{invoiceData.enterprise_address}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">注册电话</p>
            <span class="f14 color333">{{invoiceData.enterprise_tel}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票内容</p>
            <span class="f14 color333">{{invoiceData.invoice_detail}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">邮寄地址</p>
            <span class="f14 color333">{{invoiceData.addr}}</span>
          </div>
        </div>
      </div>
      <p class="title f20 color333 fontWeight mb20 mt50">发票信息</p>
      <el-form label-width="120px" :model="invoiceForm" :rules="invoiceFormrules" ref="invoiceForm" class="delivery">
        <el-form-item label="发票类型" prop="invoice_type">
          <el-select v-model="invoiceForm.invoice_type" placeholder="请选择发票类型" clearable @change="changeType()">
            <el-option label="全电发票(专用发票)" value="183"></el-option>
            <el-option label="全电发票(普通发票)" value="184"></el-option>
            <el-option label="增值税普通发票（电子发票）" value="181"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="invoice_email_id">
          <el-select v-model="invoiceForm.invoice_email_id" placeholder="请选择电子邮箱" clearable>
            <el-option v-for="email in emailData" :key="email.id" :label="email.email"
                       :value="email.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addInvoiceVisible=false">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" :disabled="!isCanSubmit"
                   @click="submitInvoiceForm('invoiceForm')">保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    applyList, applyDetail,
    emailList, emailAdd, emailUpdate, emailDelete,
    invoiceTitle, invoiceRecordList, invoiceApplyAdd,
    emailSetDefault, applyExport, deliveryLog
  } from '../../api/basisMG'
  import {
    locationArea
  } from '../../api/commonMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate, timestampToMonth} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, // 是显示加载
        dialogTitle: '',
        dialogTitle1: '',
        addInvoiceVisible: false,
        detailVisible: false, // 服务费开票-控制编辑页面显示与隐藏
        applyVisible: false,  // 开票记录详情-控制编辑页面显示与隐藏
        emailDialogVisible: false,  // 电子邮箱-控制编辑页面显示与隐藏
        searchDate: '',
        searchDate1: '',
        formDate: '',
        applyId: '',
        apply_no: '',
        detailData: {},
        productId: '',
        productId1: '',
        invoiceData: {},
        selectTableData: [],
        selectTableData1: [],
        size: '',
        provinceList: [],
        cityList: [],
        areaList: [],
        formInline: {
          page: 1,
          rows: 10,
          start_invoice_month: '',
          end_invoice_month: ''
        },
        formInline1: {
          page: 1,
          rows: 10,
          id: '',
          invoice_status: '',
          start_invoice_month: '',
          end_invoice_month: '',
          apply_no: ''
        },
        formInline4: {
          page: 1,
          rows: 10,
          id: '',
          email: ''
        },
        rules: {
          receiver_name: [{required: true, message: '请输入收件人', trigger: 'blur'}],
          mobile: [{required: true, message: '请输入电话号码', trigger: 'blur'}],
          province_code: [{required: true, message: '请选择省份', trigger: 'blur'}],
          city_code: [{required: true, message: '请选择市', trigger: 'blur'}],
          area_code: [{required: true, message: '请选择区', trigger: 'blur'}],
          addr: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
          zip_code: [{required: true, message: '请输入邮政编码', trigger: 'blur'}],
          is_default: [{required: true, message: '请选择是否为默认', trigger: 'blur'}],
          email: [{required: true, message: '请输入电子邮箱', trigger: 'blur'}],
        },
        invoiceFormrules: {
          invoice_type: [{required: true, message: '请选择发票类型', trigger: 'blur'}],
          invoice_email_id: [{required: true, message: '请选择电子邮箱', trigger: 'blur'}],
          // invoice_addr_id: [{required: true, message: '请选择邮寄地址', trigger: 'blur'}],
        },
        rules1: {
          is_default: [{required: true, message: '请选择是否为默认', trigger: 'blur'}],
          email: [{required: true, message: '请输入电子邮箱', trigger: 'blur'}],
        },
        emailForm: {
          id: '',
          email: '',
          is_default: ''
        },
        listData: [], //用户数据
        listData1: [], //用户数据
        listData4: [], //用户数据
        amountData: [],
        applyData: {},
        currentPageDetail: 1,  // 开票记录详情-当前页码
        pageSizeDetail: 10,    // 开票记录详情-每页的数据条数
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm4: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        productDate: '',//出厂日期
        validityDate: '',//有效期
        activeName: 'first',
        is_default: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        InvoicineData: [],
        isCanSubmit: true,
        orderTable: [],
        invoiceForm: {
          id: "",
          invoice_record_ids: [],
          invoice_type: '',
          invoice_email_id: "",
          seller_invoice_id: ""
        },
        emailData: [],
        addressData: [],
        invoiceInfo: {},
        logs: [],
        logsLength: 3,
        delivery_no: '',
        deliveryData: [],
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        delivery_company_name: '',
        delivery_name: '',
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getData(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      Invoicing() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请至少选择一条数据再操作!');
          return
        }
        this.invoiceForm.invoice_record_ids = [];
        this.invoiceForm.invoice_type = '';
        // this.invoiceForm.invoice_addr_id = '';
        this.invoiceForm.invoice_email_id = '';
        this.selectTableData.forEach((item) => {
          this.invoiceForm.invoice_record_ids.push(item.id)
        })
        this.InvoicineData = this.selectTableData
        this.addInvoiceVisible = true;
        invoiceTitle()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.invoiceData = res.content;
                this.invoiceForm.seller_invoice_id = res.content.id;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        this.getEmail()
      },
      //获取邮箱
      getEmail() {
        let data = {
          page: 1,
          rows: 1000,
          id: '',
          email: ''
        };
        emailList(data)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.emailData = res.content.rows;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 发票电子邮箱-新增按钮
      addEmail() {
        this.emailDialogVisible = true;
        this.dialogTitle1 = '新增发票电子邮箱';
        this.emailForm = {};
      },
      // 发票电子邮箱-修改按钮
      editEmail() {
        if (this.selectTableData1.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData1.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId1 = this.selectTableData1[0].id;
        this.dialogTitle1 = '修改发票电子邮箱';
        this.emailDialogVisible = true;
        this.emailForm.email = this.selectTableData1[0].email;
        this.emailForm.is_default = this.selectTableData1[0].is_default;
      },
      // 发票电子邮箱-删除按钮
      delEmail() {
        if (this.selectTableData1.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData1.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否确认删除发票电子邮箱？';
        this.$confirm(title, '删除发票发票电子邮箱', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          emailDelete(this.selectTableData1[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getData4(this.formInline4)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 获取公司列表1-0
      getData(parameter) {
        this.loading = true
        invoiceRecordList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getData(this.formInline)
      },
      // 获取公司列表1-1
      getData1(parameter) {
        this.loading = true
        applyList(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData1 = res.content.rows
              // 分页赋值
              this.pageparm1.currentPage = this.formInline1.page
              this.pageparm1.pageSize = this.formInline1.rows
              this.pageparm1.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.rows = parm.pageSize
        this.getData1(this.formInline1)
      },
      // 获取公司列表1-2
      getData2(parameter) {
        this.loading = true
        invoiceTitle(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.invoiceData = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 获取公司列表1-4
      getData4(parameter) {
        this.loading = true
        emailList(this.formInline4)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData4 = res.content.rows;
              // 分页赋值
              this.pageparm4.currentPage = this.formInline4.page
              this.pageparm4.pageSize = this.formInline4.rows
              this.pageparm4.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather4(parm) {
        this.formInline4.page = parm.currentPage
        this.formInline4.rows = parm.pageSize
        this.getData4(this.formInline4)
      },
      // 发票电子邮箱-弹窗
      saveEmail(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle1 == '新增发票电子邮箱') {
              emailAdd(this.emailForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加发票电子邮箱!'
                    });
                    this.emailDialogVisible = false;
                    this.getData4(this.formInline4)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.emailForm.id = this.productId1;
              emailUpdate(this.emailForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改发票电子邮箱!'
                    });
                    this.emailDialogVisible = false;
                    this.getData4(this.formInline4)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        if (this.searchDate) {
          this.formInline.start_invoice_month = timestampToMonth(this.searchDate[0])
          this.formInline.end_invoice_month = timestampToMonth(this.searchDate[1])
        } else {
          this.formInline.start_invoice_month = ''
          this.formInline.end_invoice_month = ''
        }
        this.formInline.page = 1;
        this.getData(this.formInline)
      },
      search1() {
        if (this.searchDate1) {
          this.formInline1.start_invoice_month = timestampToMonth(this.searchDate1[0])
          this.formInline1.end_invoice_month = timestampToMonth(this.searchDate1[1])
        } else {
          this.formInline1.start_invoice_month = ''
          this.formInline1.end_invoice_month = ''
        }
        this.formInline1.page = 1;
        this.getData1(this.formInline1)
      },
      search4() {
        this.formInline4.page = 1;
        this.getData4(this.formInline4)
      },

      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleSelectionChange1(val) {
        this.selectTableData1 = val
      },
      handleClose1() {
        this.$refs["emailForm"].resetFields();
        this.emailDialogVisible = false;
      },
      handleClick(tab, event) {
        console.log(tab.index)
        if (tab.index == 0) {
          this.getData(this.formInline)
        } else if (tab.index == 1) {
          this.getData1(this.formInline1)
        } else if (tab.index == 2) {
          this.getData2()
        } else if (tab.index == 3) {
          this.getData4(this.formInline4)
        }
      },
      // 服务费开票-查看详情界面
      detail(id) {
        localStorage.setItem('path', '/finance/invoiceDetail')
        let tag = {
          url: "/finance/invoiceDetail",
          menuname: "账单详情"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/finance/invoiceDetail', query: {invoice_id: id}})
      },
      // 开票记录-查看详情界面
      detailApply: function (id, apply_no, delivery_no, delivery_name) {
        this.applyId = id;
        this.apply_no = apply_no;
        this.delivery_no = delivery_no;
        this.delivery_name = delivery_name
        this.applyVisible = true
        this.loading = true
        applyDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.invoiceInfo = res.content.invoiceInfo;
                this.amountData = res.content.invoiceRecords;
                this.logs = res.content.logs;
                this.logsLength = res.content.logs.length;
                if (res.content.logs.length == 2) {
                  let log2 = {
                    content: "开票完成",
                    create_time: "等待开票完成"
                  }
                  this.logs = res.content.logs;
                  this.logs.push(log2)
                } else if (res.content.logs.length == 1) {
                  let log1 = {
                    content: "财务开票",
                    create_time: "等待开票"
                  }
                  let log2 = {
                    content: "开票完成",
                    create_time: "等待开票完成"
                  }
                  this.logs = res.content.logs;
                  this.logs.push(log1)
                  this.logs.push(log2)
                } else {
                  this.logs = res.content.logs;
                }
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      closeDialog() {
        this.applyVisible = false
      },
      // 服务费开票-开票
      exportExcel() {
        billRecordExcel(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '对账单信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      //添加发票
      submitInvoiceForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false
            invoiceApplyAdd(this.invoiceForm)
              .then(res => {
                this.isCanSubmit = true;
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                  this.getData(this.formInline)
                  this.addInvoiceVisible = false;
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      downloadInvoice(url) {
        if (url) {
          if (url.indexOf('.pdf') > -1) {
            const a = document.createElement('a');
            a.style.display = 'none';
            a.setAttribute('target', '_blank');
            a.setAttribute('download', '电子发票');
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else {
            window.location.href = url
          }
        } else {
          this.$message({
            type: 'info',
            message: '暂无电子发票'
          })
        }
      },
      changeEmailStatus(id) {
        emailSetDefault(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '已将状态设置为默认!'
              });
              this.getData4(this.formInline4)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      exportFile() {
        this.loading = true;
        applyExport(this.applyId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '开票账单明细-' + this.apply_no + '.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      lookDelivery() {
        deliveryLog(this.delivery_no)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.delivery_company_name = res.content.delivery_company_name;
                this.delivery_no = res.content.delivery_no;
                this.deliveryData = res.content.logs
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //改变类型清空值
      changeType() {
        this.invoiceForm.invoice_email_id = '';
        this.emailData.forEach((item) => {
          if (item.is_default) {
            this.invoiceForm.invoice_email_id = item.id
          }
        })
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.receiver_name == cell.innerText || row.mobile == cell.innerText || row.email == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  };
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .color409EFF {
    color: #409eff;
  }

  .flex_box {
    display: flex;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .flex_box {
    display: flex;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  /deep/ .financeForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .financeForm .el-input {
    width: 320px;
  }

  /deep/ .financeForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .financeForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .financeForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .financeForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .financeForm .el-input--small {
    width: 320px;
  }

  .tions {
    width: 50%;
  }

  .tions span {
    width: 400px;
  }

  /deep/ .tions .el-descriptions__header {
    border-bottom: 1px solid #f4f4f4;
    padding: 14px 20px;
  }

  /deep/ .tions .el-descriptions__body {
    padding: 0 20px;
  }

  /deep/ .el-dialog {
    border-radius: 8px !important;
  }

  /deep/ .el-dialog__body {
    padding: 30px 50px !important;
  }

  /deep/ .my-label {
    width: 120px !important;
    background: #EBEEF5;
  }

  /deep/ .my-content {
    width: 250px !important;
  }

  /deep/ .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 0 !important;
    border-bottom: 1px solid #F5F7FA !important;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 500px;
  }

  /deep/ .delivery .el-input--small {
    width: 500px;
  }

  /deep/ .logs .el-icon-check:before {
    color: #67C23A;
  }
</style>



// WEBPACK FOOTER //
// src/views/finance/serviceInvoicie.vue